import Reveal from "./Reveal";

const STATS = [
  { value: "6 Categories", label: "Product verticals" },
  { value: "15+ Countries Served", label: "Global buyers" },
  { value: "End-to-End Trade Support", label: "Sourcing to shipping" },
];

export default function AboutUs() {
  return (
    <section id="about" className="section-shell bg-bg">
      <div className="section-inner">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <Reveal>
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] shadow-lg border border-border">
              <img
                src="https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=900&q=80"
                alt="Warehouse and logistics operations"
                loading="lazy"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent pointer-events-none" />
            </div>
          </Reveal>

          <div>
            <Reveal delay={80}>
              <p className="label-cap text-accent mb-3">Who We Are</p>
              <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-primary tracking-tight leading-tight">
                Your Sourcing Partner in India
              </h2>
            </Reveal>

            <Reveal delay={160}>
              <p className="mt-5 text-muted leading-relaxed">
                B&amp;S Global Ventures connects international buyers with verified manufacturers and
                suppliers across India&apos;s textile, leather, footwear, jewellery, and food production
                hubs. We handle sourcing, quality control, consolidation, and export logistics — so
                buyers deal with one partner instead of dozens of factories.
              </p>
            </Reveal>

            <Reveal delay={220}>
              <p className="mt-4 text-muted leading-relaxed">
                With experience across six product categories and a network spanning major Indian
                manufacturing clusters, we simplify cross-border trade for retailers, distributors, and
                e-commerce businesses worldwide.
              </p>
            </Reveal>

            <Reveal delay={280}>
              <div className="mt-8 flex flex-wrap gap-4 md:gap-6">
                {STATS.map((stat) => (
                  <div
                    key={stat.value}
                    className="flex-1 min-w-[140px] px-4 py-3 rounded-xl bg-surface border border-border"
                  >
                    <p className="text-sm font-semibold text-primary">{stat.value}</p>
                    <p className="text-xs text-muted mt-0.5">{stat.label}</p>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
